module.exports = __webpack_public_path__ + "img/phone-operator@2x.e34b5aa4.png";